// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"633f7168","453":"82c16dc1","524":"6a60f47d","564":"83b6bd26"}[chunkId] + ".chunk.js";
};